<template>
  <div>
    <a-card
      size="small"
      title="查询"
      :headStyle="{
        background: '#f3f3f3',
      }"
    >
      <a-form layout="inline">

        <a-form-item>
          <a-select
              v-model:value="selectValue"
              label-in-value
              style="width: 120px"
              :options="orderType"
              @change="handleSelectChange"
          >
          </a-select>
        </a-form-item>

        <a-form-item>
          <df-selectChannelShop
            @setValue="searchAction()"
            :model="searchForm"
          ></df-selectChannelShop>
        </a-form-item>
        <a-form-item>
          <a-input
            v-model:value="searchForm.code"
            allowClear
            @keyup.enter.native="searchAction()"
            :placeholder="'请输入' + codeType"
          >
            <template v-slot:addonBefore>
              <a-select v-model:value="codeType" style="width: 100px">
                <a-select-option value="订单编号"> 订单编号 </a-select-option>
                <a-select-option value="渠道编号"> 渠道编号 </a-select-option>
                <a-select-option value="顾客姓名"> 顾客姓名 </a-select-option>
                <a-select-option value="电话号码"> 电话号码 </a-select-option>
              </a-select>
            </template>
          </a-input>
        </a-form-item>

        <a-form-item>
          <df-selectStationList
            :region="searchForm.from"
            @setValue="setValue"
          ></df-selectStationList>
        </a-form-item>
        <a-form-item> -- </a-form-item>
        <a-form-item>
          <df-selectStationList
            :title="'终到站'"
            :region="searchForm.to"
            @setValue="setValue"
          ></df-selectStationList>
        </a-form-item>

        <a-form-item>
          <a-range-picker
            v-model:value="searchForm.date"
            :placeholder="['出票开始', '出票结束']"
            valueFormat="YYYY-MM-DD"
            format="YYYY-MM-DD"
          />
        </a-form-item>

        <a-form-item>
          <a-range-picker
            v-model:value="searchForm.orderdate"
            :placeholder="['下单开始', '下单结束']"
            valueFormat="YYYY-MM-DD"
            format="YYYY-MM-DD"
          />
        </a-form-item>

        <a-form-item>
          <a-button type="primary" @click="searchAction"> 查询 </a-button>
        </a-form-item>

        <a-form-item>
          <a-button type="primary" @click="ordersDownload">下载 </a-button>
        </a-form-item>

        <a-form-item>
          <a-button @click="reset">重置</a-button>
        </a-form-item>
        <a-form-item> </a-form-item>
      </a-form>
    </a-card>

    <a-card
      size="small"
      title=""
      :defaultActiveTabKey="activeKey"
      style="margin-top: 20px"
      @tabChange="cardtabChange"
      class="log_content"
      :headStyle="{
        background: '#f3f3f3',
      }"
      :bodyStyle="{
        padding: '0',
      }"
      :tabList="panes"
    >
      <!-- <template v-slot:extra>
        <div slot="tabBarExtraContent">
          <a-button type="danger">暂停自动出票</a-button>

          <a-tag color="pink" closable  style='margin-left:5px'>
              宝贝格子
          </a-tag>
          <a-tag color="pink" closable >
              两把铲子
          </a-tag>

        </div>
      </template> -->
      <!-- @close="log -->

      <a-table
        :columns="columns"
        bordered
        :data-source="list"
        :pagination="false"
        :scroll="{ x: 1300 }"
        :row-key="(r) => r.id"
        :loading="loading"
      >
        <template v-slot:orderCode="{ text, record }">
          <div
            style="color: #464c5b; cursor: pointer"
            @click="toDetail(record)"
          >
            {{ record.orderCode }}
          </div>
        </template>

        <template v-slot:train="{ text, record }">
          <div>
            {{ record.fromStation }} -> {{ record.toStation
            }}<span style="color: red; margin-left: 10px"
              >({{ record.trainNo }})</span
            >
          </div>
          <div>
            {{ record.fromTimeFormat }}&nbsp;&nbsp; - &nbsp;&nbsp;{{
              record.toTimeFormat
            }}
          </div>
        </template>

        <template v-slot:passengersList="{ text, record }">
          <a-table
            :columns="columnsInner"
            bordered
            :data-source="record.passengersList"
            :pagination="false"
            :showHeader="false"
            :row-key="(r) => r.id"
          >
            <template v-slot:site="{ text, record }">
              {{ record.lastCoach }}/{{ record.lastSeat }}
            </template>
          </a-table>
        </template>

        <template v-slot:money="{ text, record }">
          <span style="color: red">¥{{ record.totalAmount }}</span>
        </template>

        <template v-slot:orderState="{ text, record }">
          {{ record.orderStateValue }}
        </template>

        <template v-slot:operation="{ text, record }">
          <a-button type="primary" @click="toDetail(record)">
            查看订单
          </a-button>
          <!-- <a-button type="danger" style='margin-left:5px' @click="cancel(record)" v-if='record.orderState == 30 || record.orderState == 60'>
            取消订单
          </a-button> -->
        </template>
      </a-table>
    </a-card>

    <df-pagination :model="pageObj"></df-pagination>

    <a-modal v-model="modalVisible" title="暂停自动出票">
      <!-- @ok="handleOk" -->
      <a-form
        layout="horizontal"
        ref="submitForm"
        :model="submitForm"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-item label="暂停渠道" prop="companyName">
          <a-input
            v-model="submitForm.companyName"
            placeholder="企业名称"
            style="width: 282px"
          />
        </a-form-item>

        <a-form-item label="结束时间" prop="companyName">
          <a-date-picker
            format="YYYY-MM-DD HH:mm:ss"
            :disabled-date="disabledDate"
            :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import orderApi from "@axios/order";
import moment from "moment";
import { reactive, ref, provide } from "vue";
import orderState from "@assets/static";
import { useRouter } from "vue-router";
import { message,Modal, destroyAll, notification } from "ant-design-vue";
import { SmileOutlined } from "@ant-design/icons-vue";
import excelApi from "@axios/downloadExcel";
import tools from "@/utils/tools";
import {SelectTypes} from "ant-design-vue/es/select";


export default {
  name: "shop",
  components: {
    SmileOutlined,
  },
  setup: function () {
    const router = useRouter();
    const columnsInner = [
      {
        title: "票号",
        dataIndex: "ticketNo",
        width: 100,
        align: "center",
      },
      {
        title: "购票人",
        dataIndex: "passengerName",
        width: 100,
        align: "center",
      },
      {
        title: "座位",
        dataIndex: "orderCode",
        width: 100,
        align: "center",
        slots: {customRender: "site"},
      },
    ];
    let panes = ref([
      {tab: "全部", key: "0"},
      {tab: "占座中", key: "20"},
      {tab: "占座成功", key: "30"},
      {tab: "出票中", key: "40"},
      {tab: "占座失败", key: "60"},
      {tab: "取消订单", key: "90"},
      {tab: "已出票", key: "50"},
      {tab: "退票订单", key: "refund"}
    ]);
    let modalVisible = ref(false);
    let visible = ref(false);
    let loading = ref(false);
    let submitForm = reactive({});
    let searchForm = reactive({
      distributorId: undefined,
      code: "",
      type: '',
      passenger: "",
      date: [],
      orderdate: [],
      from: "",
      to: "",
    });
    let searchParams = reactive({
      distributorId: undefined,
      code: "",
      type: "",
      passenger: "",
      date: [],
      orderdate: [],
      from: "",
      to: "",
    });
    let list = ref([]);

    let pageObj = ref({
      page: 1,
      rows: 10,
      totle: 1,
    });

    let activeKey = ref("0");

    const pageChange = (page) => {
      pageObj.value.page = page;
      getList();
    };

    const onShowSizeChange = (current, pageSize) => {
      pageObj.value.page = 1;
      pageObj.value.rows = pageSize;
      getList();
    };

    const cardtabChange = (key) => {

      if (key === "refund") {
        console.log("cardtabChange{}", key)
        router.replace({
          path: "/order/refundOrder",
        });
        return
      }
      activeKey.value = key;
      reset();
    };

    provide("pageChange", pageChange);
    provide("onShowSizeChange", onShowSizeChange);

    const searchAction = () => {
      searchParams.distributorId = searchForm.distributorId;
      searchParams.code = searchForm.code;
      searchParams.type = searchForm.type;
      searchParams.date = searchForm.date;
      searchParams.orderdate = searchForm.orderdate;
      searchParams.from = searchForm.from;
      searchParams.to = searchForm.to;

      pageObj.value = {
        page: 1,
        rows: 10,
        totle: 1,
      };
      getList();
    };

    const handleSelectChange = value => {
      console.log(value); //
      console.log("selectValue{}", selectValue);
      searchForm.type = value.key
      getList();
    }

    const getList = () => {
      loading.value = true;
      let params = {
        distributorId: searchParams.distributorId,
        orderState: activeKey.value == "0" ? null : activeKey.value,
        fromStation: searchParams.from ? searchParams.from : null,
        toStation: searchParams.to ? searchParams.to : null,
        currentPage: pageObj.value.page,
        size: pageObj.value.rows,
      };

      if (searchParams.orderdate.length) {
        params.orderBeginTime = searchParams.orderdate[0];
        params.orderEndTime = searchParams.orderdate[1];
      }

      if (searchParams.date.length) {
        params.finishBeginTime = searchParams.date[0];
        params.finishEndTime = searchParams.date[1];
      }
      if (searchParams.code) {
        if (codeType.value == "订单编号") {
          params.code = searchParams.code;
        } else if (codeType.value == "顾客姓名") {
          params.passengerName = searchParams.code;
        } else if (codeType.value == "电话号码") {
          params.mobile = searchParams.code;
        } else {
          params.channelCode = searchParams.code;
        }
      }

      params.type = searchForm.type

      console.log("search list params:", params)

      //获取当前登录用户
      var userName = localStorage.getItem("userName")
      console.log("current userName params:{}", userName)
      if (userName === 2025081867667){
         params.distributorId = 1061
      }


      getCount(params);

      orderApi.getOrderList(params).then((res) => {
        loading.value = false;
        if (!res) return;
        pageObj.value.totle = res.total;
        pageObj.value.page = res.page;
        list.value = res.data;
      });
    };


    const ordersDownload = () => {
      searchParams.distributorId = searchForm.distributorId;
      searchParams.code = searchForm.code;
      searchParams.date = searchForm.date;
      searchParams.orderdate = searchForm.orderdate;
      searchParams.from = searchForm.from;
      searchParams.to = searchForm.to;

      let params = {
        distributorId: searchParams.distributorId,
        orderState: activeKey.value == "0" ? null : activeKey.value,
        fromStation: searchParams.from ? searchParams.from : null,
        toStation: searchParams.to ? searchParams.to : null,
      };
      if (searchParams.orderdate.length) {
        params.orderBeginTime = searchParams.orderdate[0];
        params.orderEndTime = searchParams.orderdate[1];
      }

      if (searchParams.date.length) {
        params.finishBeginTime = searchParams.date[0];
        params.finishEndTime = searchParams.date[1];
      }
      if (searchParams.code) {
        if (codeType.value == "订单编号") {
          params.orderCode = searchParams.code;
        } else if (codeType.value == "顾客姓名") {
          params.passengerName = searchParams.code;
        } else if (codeType.value == "电话号码") {
          params.mobile = searchParams.code;
        } else {
          params.channelCode = searchParams.code;
        }
      }

      if (params.orderBeginTime === undefined || params.orderBeginTime === '' || params.orderEndTime === undefined || params.orderEndTime === '') {
        message.error("请选择下单时间区间！");
        return
      }
      if (!tools.isWithinLastThreeMonths(params.orderBeginTime, params.orderEndTime)) {
        message.error("下单时间区间，不能大于三个月！");
        return
      }

      excelApi.ordersExcel(params).then((res) => {
        let blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;"}); // 为blob设置文件类型，这里以.xlsx为例
        let url = window.URL.createObjectURL(blob); // 创建一个临时的url指向blob对象
        let a = document.createElement("a");
        a.href = url;
        a.download = '订单报表' + tools.getNowDate();
        a.click();
        // 释放这个临时的对象url
        window.URL.revokeObjectURL(url);
        //getList();
      }).catch((err) => {
      });

    };

    const getCount = (params) => {
      orderApi.orderCount(params).then((res) => {
        panes.value = [
          {tab: "全部", key: "0"},
          {tab: "占座中", key: "20"},
          {tab: "占座成功", key: "30"},
          {tab: "出票中", key: "40"},
          {tab: "占座失败", key: "60"},
          {tab: "取消订单", key: "90"},
          {tab: "已出票", key: "50"},
          {tab: "退票订单", key: "refund"}
        ];

        let sum = 0;
        for (var key in res) {
          sum += res[key];
        }

        panes.value.forEach((element) => {

          element = element === "refund" ? null : element;

          if (element.key != "0" && res["count" + element.key]) {
            element.tab =
                element.tab + " ( " + res["count" + element.key] + " ) ";
          } else if (element.key == "0" && sum) {
            element.tab = element.tab + " ( " + sum + " ) ";
          }
        });
      });
    };

    const reset = () => {
      searchForm.code = "";
      searchForm.date = [];
      searchForm.orderdate = [];
      searchForm.from = "";
      searchForm.to = "";
      searchAction();
    };

    const toDetail = (row) => {
      router.push({
        name: "orderDetail",
        query: {
          code: row.orderCode,
          type: "nomalOrder",
        },
      });
    };

    const cancel = (row) => {
      Modal.confirm({
        content: "是否确定取消该订单？",
        onOk() {
          let params = {
            orderCode: row.orderCode,
          };
          orderApi.orderConcel(params).then((res) => {
            notification.open({
              message: "取消成功",
              icon: <SmileOutlined style="color: #108ee9"/>,
            });
            getList();
          });
        },
        cancelText: "取消",
        okText: "确定",
        onCancel() {
          Modal.destroyAll();
        },
      });
    };

    const setValue = (v) => {
      if (v.title == "始发站") {
        searchForm.from = v.val;
      } else {
        searchForm.to = v.val;
      }
    };

    let codeType = ref("订单编号");

    const orderType = ref([
      {
        value: '',
        label: '订单类型',
      },
      {
        value: '10',
        label: '正常订单',
      },
      {
        value: '20',
        label: '改签订单',
      },
    ]);

    const selectValue = ref({
      value: '',
      label: '订单类型',
    })

    getList();
    return {
      selectValue,
      setValue,
      codeType,
      orderType,
      cancel,
      panes,
      reset,
      searchAction,
      handleSelectChange,
      ordersDownload,
      activeKey: activeKey,
      modalVisible,
      visible,
      loading,
      submitForm,
      list,
      rules: {
        state: [{required: true, message: "请选择状态", trigger: "change"}],
      },
      stateList: [
        {
          name: "供应",
          val: 10,
        },
        {
          name: "渠道",
          val: 20,
        },
      ],
      columns: [
        {
          title: "订单编号",
          dataIndex: "orderCode",
          width: 200,
          align: "center",
          slots: {customRender: "orderCode"},
        },
        {
          title: "订单类型",
          dataIndex: "typeValue",
          width: 100,
          align: "center",
        },
        {
          title: "渠道订单号",
          dataIndex: "channelCode",
          width: 150,
          align: "center",
        },
        {
          title: "车次信息",
          dataIndex: "mobile",
          width: 300,
          align: "left",
          slots: {customRender: "train"},
        },
        {
          title: "票号/购票人/座位",
          dataIndex: "taxpayerNum",
          width: 400,
          align: "center",
          slots: {customRender: "passengersList"},
        },
        {
          title: "订单金额",
          dataIndex: "stateName",
          width: 100,
          align: "center",
          slots: {customRender: "money"},
        },
        {
          title: "渠道",
          dataIndex: "distributorName",
          width: 100,
          align: "center",
        },
        {
          title: "提交时间",
          dataIndex: "createTime",
          width: 150,
          align: "center",
        },
        {
          title: "订单状态",
          dataIndex: "22",
          width: 150,
          align: "center",
          slots: {customRender: "orderState"},
        },
        {
          title: "操作",
          align: "center",
          dataIndex: "operation",
          key: "operation",
          width: 220,
          slots: {customRender: "operation"},
        },
      ],
      searchForm,
      searchParams,
      labelCol: {span: 4},
      wrapperCol: {span: 20},
      moment,
      pageObj,
      disabledDate(current) {
        // Can not select days before today and today

        return current && current < moment().endOf("day");
      },
      cardtabChange,
      columnsInner,
      orderState,
      toDetail,
    };
  },
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.log_content /deep/ .ant-card-extra {
  float: none;
  margin-left: 0;
}
/deep/ .ant-tabs-tab-active {
  color: #1abc9c !important;
}
/deep/ .ant-tabs-tab:hover {
  color: #1abc9c !important;
}
/deep/ .ant-tabs-ink-bar {
  background-color: #1abc9c !important;
}
</style>
